import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header-intro theme-bg-primary text-white py-5" }
const _hoisted_2 = { class: "container position-relative" }
const _hoisted_3 = { class: "row g-2 g-lg-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-12 col-md-auto" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "\n              profile-medium\n              d-inline-block\n              rounded-circle\n              me-md-4\n              align-self-center\n              mb-2 mb-lg-0\n            ",
    src: "/images/profile.png",
    alt: ""
  })
], -1)
const _hoisted_5 = { class: "col align-self-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h2", { class: "page-heading mb-2" }, "Krzysztof Szumny's Blog", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "page-heading-tagline mb-3" }, [
  /*#__PURE__*/_createTextVNode(" I write about web development and life as a developer. "),
  /*#__PURE__*/_createVNode("br", { class: "d-lg-block d-none" }),
  /*#__PURE__*/_createTextVNode("You can follow me via the various channels below: ")
], -1)
const _hoisted_8 = { class: "social-list-square list-inline mb-0" }
const _hoisted_9 = {
  key: 0,
  class: "list-inline-item mb-3 mb-lg-0"
}
const _hoisted_10 = {
  key: 1,
  class: "list-inline-item mb-3 mb-lg-0"
}
const _hoisted_11 = {
  key: 2,
  class: "list-inline-item mb-3 mb-lg-0"
}
const _hoisted_12 = {
  key: 3,
  class: "list-inline-item mb-3 mb-lg-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode("ul", _hoisted_8, [
            (_ctx.links.twitterProfile)
              ? (_openBlock(), _createBlock("li", _hoisted_9, [
                  _createVNode("a", {
                    href: _ctx.links.twitterProfile
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'twitter'],
                      class: "text-white"
                    })
                  ], 8, ["href"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.links.linkedinProfile)
              ? (_openBlock(), _createBlock("li", _hoisted_10, [
                  _createVNode("a", {
                    href: _ctx.links.linkedinProfile
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'linkedin'],
                      class: "text-white"
                    })
                  ], 8, ["href"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.links.githubProfile)
              ? (_openBlock(), _createBlock("li", _hoisted_11, [
                  _createVNode("a", {
                    href: _ctx.links.githubProfile
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'github'],
                      class: "text-white"
                    })
                  ], 8, ["href"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.links.stackOverflowProfile)
              ? (_openBlock(), _createBlock("li", _hoisted_12, [
                  _createVNode("a", {
                    href: _ctx.links.stackOverflowProfile
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fab', 'stack-overflow'],
                      class: "text-white"
                    })
                  ], 8, ["href"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}